/**
 * @generated SignedSource<<99663e0b7185999012daa660118006fe>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type Badge = "BIG_PARIS_2021" | "BQH_QATAR_FINALIST_2025" | "BQH_QATAR_WINNER_2025" | "BRADFORD_BRING_YOUR_OWN_USE_CASE" | "BRADFORD_CLINICAL_TRIAL_OPTIMIZATION" | "BRADFORD_PROJECT_ELEVEN_POST_QUANTUM_CRYPTOGRAPHY" | "BRADFORD_QUANTUM_BRUSH" | "CHICAGO_2023" | "EPRI2025_FIRST" | "EPRI2025_SECOND" | "EPRI2025_THIRD" | "GIC2025_JPMC" | "GIC2025_MITRE" | "GIC2025_NEURO_QUANTUM" | "GIC2025_WELLS_FARGO" | "GIC2025_WORLD_BANK" | "GIC26USDOE" | "GIC26_MITSUBISHI" | "GIC26_QBRAID_MITRE_JONES" | "GIC26_QUANTUM_COMPUTING_INC" | "GRENOBLE_2022" | "HTH_MOST_IMPACTFUL_TEAM" | "HTH_MOST_INNOVATIVE_IDEA" | "HTH_PARTICIPATION" | "HTH_WINNER_TEAM" | "INGENII_2024_FIRST" | "INGENII_2024_OTHERS" | "INGENII_2024_SECOND" | "INGENII_2024_SPECIAL" | "INGENII_2024_THIRD" | "MONTREAL_2022" | "NOVACENE_2024" | "PARIS_2021" | "PARIS_2023" | "PARIS_2024_HACKERS" | "PARIS_2024_WINNERS" | "PUSHQUANTUM_HAIQU_EARLY_FAULT_TOLERANT_CIRCUITS" | "PUSHQUANTUM_QORO_QUANTUM_MOLECULAR_DETECTIVE" | "PUSHQUANTUM_QUANDELA_QUANTUM_OPTION_PRICING" | "Q2B2024_BRONZE" | "Q2B2024_GOLD" | "Q2B2024_ONSITE" | "Q2B2024_REMOTE" | "Q2B2024_SILVER" | "QFF_COLOR_CODE" | "QFF_QUANTUM_MACHINE_LEARNING" | "QFF_QUANTUM_RANDOM_WALK" | "QINNOVISION_2025_FINALIST" | "QINNOVISION_2025_WINNER" | "QML_SUMMER_SCHOOL_2025" | "QUANTUM_PIONEER" | "QUANTUM_SIGNALS_LOB_2025_FIRST" | "QUANTUM_SIGNALS_LOB_2025_SECOND" | "QVOLUTION_26_ENERGY" | "QVOLUTION_26_FINANCE" | "QVOLUTION_26_LINEAR_DIFF" | "QVOLUTION_26_QUANTUM_FOR_GOOD" | "TEST" | "TRIESTE_2023" | "UNKNOWN";
import { FragmentRefs } from "relay-runtime";
export type EntityBadgeFragment$data = {
  readonly badge: Badge;
  readonly " $fragmentType": "EntityBadgeFragment";
};
export type EntityBadgeFragment$key = {
  readonly " $data"?: EntityBadgeFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"EntityBadgeFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EntityBadgeFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "badge",
      "storageKey": null
    }
  ],
  "type": "EntityBadge",
  "abstractKey": null
};

(node as any).hash = "2ef70381dade5acb5b36591c321049c6";

export default node;
